export default __webpack_public_path__ + "static/media/product-list-empty.e29e85cf.svg";